module.exports = {
  textInicial: "Construído por Ápice Sistemas ®",
  versao:`Versão: 1.0.0.1`
};



// WEBPACK FOOTER //
// ./src/constants.js